/**
 * The way out under "Cannot safely cancel this game". #1113 T7 item 4: when a
 * Polymarket US order is among the blockers, say where it can be cancelled,
 * since this card's US rows are view-only.
 */
export function gameCancelBlockedAction(usBlocked: boolean): string {
  const base = 'Cancel the affected orders individually, or wait for market data to load.';
  return usBlocked ? `${base} Cancel the Polymarket US order from the side rail or Positions → Polymarket US, then retry.` : base;
}
